import { createFeatureSelector } from '@ngrx/store';
import { AppRootState } from '@root/reducers';

export const appRootSelector = createFeatureSelector<AppRootState>('root');
